import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  background: ${({ theme }) => theme.colors.stroke};
  border-radius: 4px;

  span {
    color: ${({ theme }) => theme.colors.cflowerBlue};
    user-select: none;
  }
`;
